import Footer from '@/components/Footer/Footer';
import { Header } from '@/components/header/Header';
import DrawerManager from '@/features/drawer/DrawerManager';
import { AppShell, Box } from '@mantine/core';
import { Outlet, useMatch } from 'react-router-dom';

type Props = {
  children?: React.ReactNode;
};

const Layout = ({ children }: Props) => {
  const isOnboardingPage = useMatch('/onboarding');

  const height = isOnboardingPage ? '72' : '112';

  return (
    <AppShell
      padding="md"
      header={{
        height: {
          base: height,
          sm: height,
        },
      }}
    >
      <AppShell.Header>
        <Header />
      </AppShell.Header>
      <AppShell.Main
        style={{
          minHeight: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        }}
      >
        <Box style={{ flex: 1 }}>{children || <Outlet />}</Box>
        <Footer />
      </AppShell.Main>
      <DrawerManager />
    </AppShell>
  );
};

export default Layout;
